import {createApp} from 'vue';
import {createRouter, createWebHistory} from 'vue-router';
import OshiTagSearch from './components/OshiTagSearch.vue';
import ChatApp from './components/ChatApp.vue';
import Match from './components/Match.vue';
import Sortable from 'sortablejs';
import {fetchTokenBalances} from './stores/tokenBalanceStore.js';
import './styles/chatSendModal.css';

window.OshiSortable = Sortable;
document.dispatchEvent(new Event('oshi-sortable-ready'));

const oshiTagArea = document.getElementById('oshi-tag-area');
if (oshiTagArea) {
  const initialData = JSON.parse(oshiTagArea.dataset.initial);
  const router = createRouter({history: createWebHistory(), routes: [
    {path: initialData.pageUrl, component: {template: '<span></span>'}},
  ]});
  const app = createApp(OshiTagSearch, {initialData});
  app.use(router);
  router.isReady().then(() => app.mount(oshiTagArea));
}

const matchingArea = $('#matching-area').get(0);

if (matchingArea !== undefined) {
  createApp(Match, {
    appEnvironment: document.body.dataset.appEnvironment || 'prod',
    isAuthenticated: $(matchingArea).data('is-authenticated') === true,
    loginUrl: $(matchingArea).data('login-url'),
    oshiDetailUrlTemplate: $(matchingArea).data('oshi-detail-url-template'),
    previewMode: matchingArea.dataset.previewMode === 'true',
    previewCandidate: matchingArea.dataset.previewCandidate
      ? JSON.parse(matchingArea.dataset.previewCandidate)
      : null,
  }).mount(matchingArea);
}

const chatArea = $('#chat-area').get(0);

if (chatArea !== undefined) {
  // 初回取得失敗は送信時に再試行するため、この時点では画面へ通知しない。
  fetchTokenBalances().catch(() => {});
  const initialData = JSON.parse($(chatArea).attr('data-chat'));
  const detailPath = initialData.chat_detail_url_template.replace('%public_customer_id%', ':public_customer_id');
  const EmptyRoute = {template: '<span></span>'};
  const router = createRouter({
    history: createWebHistory(),
    routes: [
      {path: initialData.chat_list_url, name: 'chat-list', component: EmptyRoute},
      {path: detailPath, name: 'chat-detail', component: EmptyRoute},
    ],
  });

  createApp(ChatApp, {initialData}).use(router).mount(chatArea);
}
